import { render, staticRenderFns } from "./Salaries.vue?vue&type=template&id=8ab56ff0&scoped=true"
import script from "./Salaries.vue?vue&type=script&lang=js"
export * from "./Salaries.vue?vue&type=script&lang=js"
import "./Salaries.vue?vue&type=style&index=0&id=8ab56ff0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab56ff0",
  null
  
)

export default component.exports